// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Lgj_","box":"WorkspacesBox_box__3_fqo","node":"WorkspacesBox_node__39q0h"};